<div class="cover-container d-flex w-100 h-100 mx-auto flex-column" style="background-image: url(assets/img/download-bg.jpg);background-size:cover ;">
    <div class="position-relative overflow-hidden h-100 outerPanelCutomBranding" style="background-color:#fff">
        @if (currentUser.background_type == '0') {
            <div class="backgroundColorChangeBoxStaticImage"></div>
        }
        <div class="backgroundColorChangeBox" [style]="currentUser.background_type == '0'?'background:'+currentUser.background_color+'':''"></div>

        <header class="mb-auto">
            <div style="position: relative;z-index: 111;">
              <a href="{{companyOwnWebsite}}" target="_blank"><img [src]="LogoUrl=='' || LogoUrl == 'null' || LogoUrl == null ? 'assets/img/211228_Logo2_RGB.svg' : LogoUrl " class="float-md-start mb-0 blah logo"></a>
              @if (companyName != '' || companyName !='null'  || companyName != null) {
                <p class="companyName">{{companyName}}</p>
              }
            </div>
          </header>

        <div class="cover-container d-flex w-100 h-100 mx-auto flex-column position-relative downloadPageContainerMain d-flex aligns-items-center justify-content-center" [style]="currentUser.background_type == '1'?'background-image:url('+currentUser.background_image_path+')':''" style="background-size: cover;">
          <main class="px-3">
              <div class="container">
                  <div class="row gutters justify-content-md-center">
                    <div class="col-xl-8 col-lg-10 col-md-12 col-sm-12 col-12 otpContainer">
                        <div class="card text-center mt-3 bg-transparent" style="box-shadow: none;">
                            <div class="card-body pt-5 pb-5 bg-transparent">
                                <div class="success-icon-container mb-4">
                                    <i class="fa fa-check-circle" style="font-size: 80px; color: #2196f3;"></i>
                                </div>
                                <h2 class="mb-4" style="font-weight: 600; font-size: 28px; color: #2196f3;">
                                    {{'domain_propagation_successful' | translate}}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
          </main>
          <app-footer></app-footer>
        </div>
    </div>
</div>
